import { TextField } from '@mui/material';
import debounce from '@mui/utils/debounce';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { format, isMatch } from 'date-fns';
import { DATE_FORMAT } from '../lib/date_time';
import { useUserConfiguration } from '../providers/UserConfigurationProvider';

interface SelectDateProps {
  currentDate: string;
  onDateSelected: (dateString: string) => void;
  label?: string;
  disableFutureDate?: boolean;
  minDateValue?: string;
  disabled?: boolean;
}

export function SelectDate(props: SelectDateProps) {
  const {
    currentDate,
    onDateSelected,
    label,
    disableFutureDate = false,
    minDateValue = undefined,
    disabled = false,
  } = props;

  const { globalDateFormat } = useUserConfiguration();

  const updateUpwards = debounce((date: string) => {
    onDateSelected(date);
  }, 500);

  const onChangeDate = (values: string) => {
    if (isMatch(values, DATE_FORMAT)) {
      updateUpwards(values);
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DesktopDatePicker
        value={currentDate}
        label={label ?? undefined}
        onChange={(newValue) => {
          if (newValue) {
            const formatDate = format(new Date(newValue), DATE_FORMAT);
            onChangeDate(formatDate);
          }
        }}
        disableFuture={disableFutureDate}
        disabled={disabled}
        minDate={minDateValue}
        renderInput={(params) => (
          <TextField
            {...params}
            sx={{ width: 140 }}
            id="date"
            variant="standard"
            inputProps={{ ...params.inputProps, readOnly: true }}
            size="small"
            fullWidth={false}
            InputLabelProps={{
              shrink: true,
            }}
          />
        )}
        inputFormat={globalDateFormat.split(' ')[0]}
      />
    </LocalizationProvider>
  );
}
